function checkPhone (userPhone) {
  if (userPhone === '' || userPhone === null) {
    return { data: false, msg: 'Please enter your mobile phone number' }
  }
  var telreg = /^(((1[0-9]{1}[0-9]{1}))+\d{8})$/
  if (!telreg.test(userPhone)) {
    return { data: false, msg: 'Incorrect mobile number format' }
  }
  return { data: true, msg: '' }
}
function checkUsername (username) {
  if (username === '' || username === null) return { data: false, msg: ' ' }
  var usernameReg = /.{2,20}/
  if (!usernameReg.test(username)) {
    return { data: false, msg: 'Please enter a name with 2 to 20 characters' }
  }
  return { data: true, msg: '' }
}
function checkPassword (password) {
  if (password === '' || password === null) return { data: false, msg: ' ' }
  var passwordReg = /.{6,}/
  if (!passwordReg.test(password)) {
    return {
      data: false,
      msg: 'Please enter a password of no less than 6 digits'
    }
  }
  return { data: true, msg: '' }
}
export default { checkPhone, checkUsername, checkPassword }



// WEBPACK FOOTER //
// ./src/utils/validate.js